export var valuesSunburstMapType = ["continuous", "piecewise"];
//# sourceMappingURL=SunburstMapType.js.map